import { useNavigate } from 'react-router-dom';
import { User, UsersRound, Workflow, Moon, Sun, Monitor, FileText } from 'lucide-react';
import { PageContainer } from '@/components/layout/PageContainer';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useThemeStore } from '@/stores/themeStore';
import { useAuthStore } from '@/stores/authStore';

export function SettingsPage() {
  const navigate = useNavigate();
  const { theme, setTheme } = useThemeStore();
  const user = useAuthStore((s) => s.user);
  const isAdmin = user?.role === 'ADMIN';

  const items = [
    { title: 'Profile', description: 'Update your personal information and password', icon: User, href: '/settings/profile', show: true },
    { title: 'Document Settings', description: 'Branding, numbering, footers, payment defaults, and agreement templates — General, Invoice, Quote, and Agreement tabs', icon: FileText, href: '/settings/documents', show: isAdmin },
    { title: 'Team Management', description: 'Manage users and their roles', icon: UsersRound, href: '/settings/team', show: isAdmin },
    { title: 'Pipeline Settings', description: 'Configure sales pipelines and stages', icon: Workflow, href: '/settings/pipelines', show: isAdmin },
  ];

  return (
    <PageContainer title="Settings" description="Manage your account and application settings">
      <div className="space-y-6">
        {/* Theme */}
        <Card>
          <CardHeader><CardTitle className="text-base">Appearance</CardTitle><CardDescription>Choose your preferred theme</CardDescription></CardHeader>
          <CardContent className="flex gap-2">
            <Button variant={theme === 'light' ? 'default' : 'outline'} onClick={() => setTheme('light')}><Sun className="mr-2 h-4 w-4" />Light</Button>
            <Button variant={theme === 'dark' ? 'default' : 'outline'} onClick={() => setTheme('dark')}><Moon className="mr-2 h-4 w-4" />Dark</Button>
            <Button variant={theme === 'system' ? 'default' : 'outline'} onClick={() => setTheme('system')}><Monitor className="mr-2 h-4 w-4" />System</Button>
          </CardContent>
        </Card>

        {/* Navigation Cards */}
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {items.filter((i) => i.show).map((item) => (
            <Card key={item.href} className="cursor-pointer hover:shadow-md transition-shadow" onClick={() => navigate(item.href)}>
              <CardHeader className="flex flex-row items-center gap-4">
                <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10"><item.icon className="h-5 w-5 text-primary" /></div>
                <div><CardTitle className="text-base">{item.title}</CardTitle><CardDescription className="text-xs">{item.description}</CardDescription></div>
              </CardHeader>
            </Card>
          ))}
        </div>
      </div>
    </PageContainer>
  );
}
